export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-900 text-background-300 pt-14 md:pt-20 pb-8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-xl font-bold text-background-50 mb-4 block">
              春夜影院
            </span>
            <p className="text-sm text-background-400 leading-relaxed">
              春夜影院提供最新电影全集与电视剧大全，免费高清在线观看。蓝光画质、流畅播放，享受沉浸式观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-background-200 transition-colors">热门榜单</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">分类索引</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors">常见问题</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-background-200 transition-colors">热门话题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">电影大全</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">电视剧库</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">综艺合集</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">动漫天地</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              诚邀优质内容方与平台加入合作伙伴计划，共同为影迷提供更丰富的观影选择。
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors mt-3"
            >
              <i className="ri-mail-line"></i>
              合作咨询
            </a>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 春夜影院 chunye.net — 免费高清在线观影平台
          </p>
          <div className="flex items-center gap-5">
            <a href="#about" className="text-xs text-background-500 hover:text-background-300 transition-colors">关于我们</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors">联系我们</a>
            <a href="#faq" className="text-xs text-background-500 hover:text-background-300 transition-colors">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}